// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_my-0";
export var animationContainer = "_my-1";
export var itemPrice = "_my-a";
export var itemizedContent = "_my-9";
export var itemizedHeader = "_my-7";
export var itemizedRow = "_my-8";
export var itemizedSection = "_my-6";
export var modalContent = "_my-2";
export var orderName = "_my-3";
export var refundOption = "_my-4";
export var refundOptionsContainer = "_my-5";
export var shippingLabel = "_my-b";
export var totalRow = "_my-c";